import React from 'react';

const Levels = () => {
  return <div>Levels (Private)</div>;
};

Levels.propTypes = {};

export default Levels;
